export const MESSAGES_NEW = "MESSAGES_NEW";
export const MESSAGES_CLEAR = "MESSAGES_CLEAR";
